import gql from "graphql-tag";

export default gql`
  mutation saveContactByMailForm(
    $siteId: Int!
    $email: String
    $firstname: String
    $lastname: String
    $message: String
  ) {
    save_contactByMailForm_default_Entry(
      siteId: $siteId
      formEmail: $email
      formFirstName: $firstname
      formLastName: $lastname
      formMessage: $message
      authorId: 195500
    ) {
      id
    }
  }
`;
